import { render, staticRenderFns } from "./BuildingRanking.vue?vue&type=template&id=02933194&scoped=true"
import script from "./BuildingRanking.vue?vue&type=script&lang=js"
export * from "./BuildingRanking.vue?vue&type=script&lang=js"
import style0 from "./BuildingRanking.vue?vue&type=style&index=0&id=02933194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02933194",
  null
  
)

export default component.exports